// extracted by mini-css-extract-plugin
export default {"tag":"Tags_tag__TLQ6-","icon":"Tags_icon__4O1QW"};